import { isServer } from "../util";

class StorageService {
  gridSizeKey = "GRID_SIZE";
  ordersHistoryKey = "ORDERS_HISTORY_FROM";
  otpTimestamp = "OTP_TIMESTAMP";

  setOrdersHistoryFrom(value) {
    localStorage.setItem(this.ordersHistoryKey, value);

    return value;
  }

  getOrdersHistoryFrom() {
    return !isServer && localStorage.getItem(this.ordersHistoryKey);
  }

  removeOrdersHistoryFrom() {
    localStorage.removeItem(this.ordersHistoryKey);
    return this.ordersHistoryKey;
  }

  get(key: string) {
    if (typeof window === "undefined") {
      return null;
    }

    const item = window.localStorage.getItem(key);

    return item ? JSON.parse(item) : null;
  }

  set(key: string, value: any) {
    if (typeof window === "undefined") {
      return;
    }

    const item = JSON.stringify(value);
    window.localStorage.setItem(key, item);
  }

  remove(key: string) {
    if (typeof window === "undefined") {
      return;
    }

    window.localStorage.removeItem(key);
  }
}

const instance = new StorageService();

export default instance;
